module.exports = __webpack_public_path__ + "img/hontai_CafeBrown.f27be601.png";